import { render } from "./PermissionForm.vue?vue&type=template&id=644bc7f4&scoped=true"
import script from "./PermissionForm.vue?vue&type=script&lang=js"
export * from "./PermissionForm.vue?vue&type=script&lang=js"

import "./PermissionForm.vue?vue&type=style&index=0&id=644bc7f4&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-644bc7f4"

export default script